import { Navigate, Route, Routes } from 'react-router-dom'

import { ROUTES } from '../../utils/routes'
import { StreamManagerContainer } from './StreamManagerContainer'
import { NetworkManagerContainer } from './NetworkManagerContainer'
import { useUser } from '../../utils'
import { Role } from 'common/api/v1/types'
import { ConfirmDialogProvider } from '../common/ConfirmDialog'
import { ContentDialogProvider } from '../common/ContentDialog'
import { HelmetProvider } from 'react-helmet-async'

const LoggedIn = () => {
  const user = useUser()

  return (
    <HelmetProvider>
      <ConfirmDialogProvider>
        <ContentDialogProvider>
          <Routes>
            <Route
              path="/*"
              element={user.role === Role.basic ? <Navigate to={ROUTES.stream} replace /> : <NetworkManagerContainer />}
            />
            <Route path="/stream/*" element={<StreamManagerContainer />} />
          </Routes>
        </ContentDialogProvider>
      </ConfirmDialogProvider>
    </HelmetProvider>
  )
}

export default LoggedIn
